export default {
  name: {},
  field: {},
  meta: {},
  cell: undefined,
  isSFC: false,
  sortable: {},
  width: null,
  tooltip: undefined,
};
